<template>
  <div>
    <orders-dashboard v-if="user.user_type == 'paad'"></orders-dashboard>
    <manager-dashboard v-if="user.user_type == 'ma'"></manager-dashboard>
    <store-keeper-dashboard v-if="user.user_type == 'stke'"></store-keeper-dashboard>
    <pending-transfers v-if="user.username == 'shelfing-admin'" ></pending-transfers>
    <partner-new-dashboard v-if="user.user_type == 'prtnr'"></partner-new-dashboard>
  {{user.user_type}}

  </div>
</template>
<script>
import GetUserApi from "@/views/panel/user/getUserApi.js";
import GoToWallet from "@/views/panel/subscription/GoToWallet";
import TransactionCard from "@/views/affiliate/componenets/TransactionCard";
import NotPaidOrdersCard from "@/views/affiliate/componenets/NotPaidOrdersCard";
import BusinessSettingCard from "@/views/affiliate/componenets/BusinessSettingCard";
import BusinessProductSelectCard from "@/views/affiliate/componenets/BusinessProductSelectCard";
import FinanceCard from "@/views/home/FinanceCard";
import EarnProfitCard from "@/views/home/EarnProfitCard";
import HomeBanner from "@/views/home/HomeBanner";
import HomeLinkBtns from "@/views/home/HomeLinkBtns";
import OrdersDashboard from "@/modules/order_admin/OrdersDashboard";
import ManagerDashboard from "@/modules/ManagerDashboard";
import StoreKeeperDashboard from "@/modules/StoreKeeperDashboard";
import PendingTransfers from "@/modules/store_handle/PendingTransfers";
import PartnerDashboard from "@/modules/partner/PartnerDashboard";
import PartnerNewDashboard from "@/modules/partner/PartnerNewDashboard";
export default {
  name: "Panel",
  mixins: [GetUserApi],
  components: {
    PartnerNewDashboard,
    PartnerDashboard,
    PendingTransfers,
    StoreKeeperDashboard,
    ManagerDashboard,
    OrdersDashboard,
    HomeLinkBtns,
    HomeBanner,
    EarnProfitCard,
    FinanceCard,
    BusinessProductSelectCard,
    BusinessSettingCard,
    NotPaidOrdersCard,
    TransactionCard,
    GoToWallet
  },
  data() {
    return {
      dialog: false,
      chart_dialog: false,
    };
  },
  mounted() {
    this.setTitle();
  },
  methods: {
    setTitle(){
      if (this.user.user_type == 'ma') {
        this.setDocumentTitle('پنل مدیریت')
      }
      else if (this.user.user_type == 'paad') {
        this.setDocumentTitle('پنل پردازش سفارشات')
      }
      else if (this.user.user_type == 'stke') {
        this.setDocumentTitle('پنل مدیریت انبار')
      }
      else if (this.user.user_type == 'stke') {
        this.setDocumentTitle('پنل انبارداری')
      }
      else if (this.user.user_type == 'prtnr') {
        this.setDocumentTitle('پنل شراکت')
      }
    },
    routeClick(routeName) {
      if (this.$route.name == routeName) {
        this.EventBus.$emit("sameRouteClick");
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
